import React from 'react';
import PropTypes from 'prop-types';
import getNavLink from './nav-links';
import NavbarDropdownHeader from './NavbarDropdownHeader';

const NavbarDropdownRight = ({ label, children }) => (
  <div className="dropdown">
    {label && <NavbarDropdownHeader link={getNavLink(label)}>{label}</NavbarDropdownHeader>}
    {children}
  </div>
);

NavbarDropdownRight.defaultProps = {
  label: undefined
};

NavbarDropdownRight.propTypes = {
  label: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default NavbarDropdownRight;
